var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpliciMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "661.5 0 111 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#08f",
    d: "M770.59,18.33c1.43,1.43,1.43,3.76,0,5.2l-42,42-19.85,19.85c-1.43,1.43-3.76,1.43-5.2,0l-40.05-40.05c-1.43-1.43-1.43-3.76,0-5.2l17.25-17.25c1.43-1.43,3.76-1.43,5.2,0l17.6,17.6c1.43,1.43,3.76,1.43,5.2,0L748.14,1.08c1.43-1.43,3.76-1.43,5.2,0l17.25,17.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpliciMark);
export default __webpack_public_path__ + "static/media/simplici-mark.55b64f720056510c7116ab2703f32386.svg";
export { ForwardRef as ReactComponent };